import React, { useState, useEffect, useMemo } from 'react';
import { object, func, bool } from 'prop-types';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import TablaItemModal from '../TablaItemModal';
import { isNull } from '../../../utils/validator';


const TablaItemsGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      disabled: false,
      idTablaDefinicion: 0,
      idTablaVersion: 0,
      list: []
  });

  const [editMode, setEditMode] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [removingId, setRemovingId] = useState(null);


  const mount = () => {
    setState(prevState => {
      const list = props.data.list.filter(x => x.state !== 'r');
      return {...prevState,
        idTablaDefinicion: props.data.idTablaDefinicion,
        idTablaVersion: props.data.idTablaVersion,
        list: list
      };
    });
  }
  useEffect(mount, [props.data]);


  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickTablaItemAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickTablaItemView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <>
                                  <div onClick={ (event) => handleClickTablaItemModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  <div onClick={ (event) => handleClickTablaItemRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Borrar">delete</span>
                                  </div>
                                  </>
                                  )}                                 
                              </div>

  const columnValues = useMemo(() => {
    if (props.data.columnas.length > 0) {
      const columnWith = Math.round(90 / props.data.columnas.length);
      const columnValues = props.data.columnas.map((column) => {return {
        Header: column.descripcion,
        accessor: `valor${column.id}`,
        id: `valor${column.id}`,
        width: columnWith
      }});

      return [...columnValues, {
        Header: props.data.resultado.descripcion,
        accessor: "valorResultado",
        sortType: props.data.resultado.tipoDato === 'string' ? 'alphanumeric' : (a, b, id) => {
          const x = parseFloat(a.values[id]) || 0;
          const y = parseFloat(b.values[id]) || 0;
          return x === y ? 0 : x > y ? 1 : -1;
        },
        width: columnWith
      }];
    }
    else {
      return [];
    }
  }, [props.data.columnas, props.data.resultado])

  const initialSortBy = useMemo(() => {
    const primeraColumna = props.data.columnas[0];
    return primeraColumna ? [{ id: `valor${primeraColumna.id}`, desc: false }] : [];
  }, [props.data.columnas])

  const tableColumns = useMemo(() => [
    ...columnValues,
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
  ], [columnValues, props.disabled, state])


  //handles
  const handleClickTablaItemAdd = () => {
    const editItem = {
      id: -Date.now(),
      idTablaDefinicion: state.idTablaDefinicion,
      idTablaVersion: state.idTablaVersion,
      valor1: '',
      valor2: '',
      valor3: '',
      valor4: '',
      valor5: '',
      valor6: '',
      valor7: '',
      valor8: '',
      valor9: '',
      valor10: '',
      valorResultado: props.data.resultado.tipoDato === "string" ? '' : "0",
      state: 'a'
    };
    setEditItem(editItem);
    setEditMode(true);
  }
  const handleClickTablaItemView = (id) => {
    const editItem = state.list.find(x => x.id === id);
    setEditItem(editItem);
    setEditMode(false);
  }
  const handleClickTablaItemModify = (id) => {
    const editItem = state.list.find(x => x.id === id);
    setEditItem(editItem);
    setEditMode(true);
  }
  const handleClickTablaItemRemove = (id) => {
      setRemovingId(id);
  }

  //funciones
  function confirmRemoveId(id) {
    const row = CloneObject(state.list.find(x => x.id === id));
    row.state = 'r';
    props.onChange('TablaItem', row);
  }
  function updateTablaItem(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('TablaItem', row);
  }

  return (
  <>
    <TableCustom
        key={props.data.idTablaVersion}
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
        initialSortBy={initialSortBy}
        csvFollowsView
    />

    {editItem && 
      <TablaItemModal
          disabled={!editMode}
          data={{
            entity: editItem,
            columnas: props.data.columnas,
            resultado: props.data.resultado
          }}
          onDismiss={() => {
            setEditItem(null)
          }}
          onConfirm={(row) => {
            updateTablaItem(row)
            setEditItem(null)
          }}
      />
    }

    {removingId && 
      <MessageModal
          title={"Confirmación"}
          message={"¿Está seguro de borrar el registro?"}
          onDismiss={() => setRemovingId(null)}
          onConfirm={() => {
            confirmRemoveId(removingId)
            setRemovingId(null)
          }}
      />
    }

  </>
  );
}

TablaItemsGrid.propTypes = {
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

TablaItemsGrid.defaultProps = {
  disabled: false
};

export default React.memo(TablaItemsGrid);